<template>
  <radio-group v-model="model[targetKey]" inline>
    <radio
      :title="$t('CampaignForm_Target_All')"
      :description="$t('CampaignForm_Target_Description')"
      :label="0"
      data-qa="target-everyone-option-radio"
      border
    />
    <radio
      :title="$t('CampaignForm_Target_Subscribed')"
      :description="$t('CampaignForm_Target_Subscribed_Description')"
      :label="1"
      data-qa="target-subscribed-option-radio"
      border
    />
    <radio
      :title="$t('CampaignForm_Target_NotSubscribed')"
      :description="$t('CampaignForm_Target_NotSubscribed_Description')"
      :label="-1"
      data-qa="target-not-subscribed-option-radio"
      border
    />
  </radio-group>
</template>

<script>
import RadioGroup from '@/common/components/form/RadioGroup'
import Radio from '@/common/components/form/Radio'
export default {
  name: 'TargetGroup',
  components: { Radio, RadioGroup },
  props: {
    model: {
      default: 0
    },
    targetKey: {
      required: true
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/segment/TargetGroup.vue